import React from 'react'
import Superface from '../Superface'

export default class MilanVideos extends React.Component{

    getVideosStyle(i){
        return {
            opacity:( (i + 1) === this.props.current ? 1 : 0 ), 
            position:'absolute', 
            width : ( window.innerWidth < 1024 ? '100%' : '80%' )
        }
    }
    
    renderVideos(){
        const videos = [
            this.props.about.video_galaxy_1.path,
            this.props.about.video_galaxy_2.path,
            this.props.about.video_galaxy_3.path,
            this.props.about.video_galaxy_4.path,
            this.props.about.video_galaxy_5.path,
            this.props.about.video_galaxy_6.path,
        ]
        return videos.map( (path, i) => {
            return(
                <video 
                    style={this.getVideosStyle(i)}
                    key={'milan-videos-'+i} 
                    src={Superface.assetUrl(path)} 
                    autoPlay 
                    loop 
                    ></video>
            )
        })
    }

	render() {
        if( !this.props.about ) return <span></span>
		
		return (
			<div
                id="milan-videos"
				style={{ width: '100%', height: '100%', zIndex:10, position:'absolute', display:'flex', alignItems:'center', justifyContent:'center', pointerEvents:'none' }}
			>
                
                {this.renderVideos()}

            </div>
		)
    }
    
}


// WEBPACK FOOTER //
// ./src/components/AboutMilanVideos.js